import React from 'react';
import PropTypes from 'prop-types';

import LinkButton from '../atoms/button/LinkButton';
import Flight from './Flight';

import PlanContent from './PlanContent';
import ItinerarySchedule from './ItinerarySchedule';
import PlanDateTitle from '../atoms/titles/PlanDateTitle';
import { ENABLE_MULTIPLE_HOTEL_PLAN } from '../../constants';

const SubscriptionPlanContentsItem = ({
  index,
  outboundFlight,
  inboundFlight,
  dateDisplay,
  plan,
  handleOutboundFlightChange,
  handleInboundFlightChange,
  handlePlanChange,
  handlePlanDelete,
  cantChangeFlight,
  cantChangeHotel,
  cantDeleteHotel,
  handleUpdateCheckin,
  finalConfirm,
  hideCheckin,
  handleUpdateQuestion,
  showQuestions,
  hideMessage,
}) => {
  let message = '';
  if (plan && plan.hotel) {
    message = plan.hotel.message;
  }

  const accessCaution = (
    <div style={{ margin: '15px auto 0', maxWidth: 350, fontSize: '10px' }}>
      ※空港～宿泊施設間のアクセス・所要時間は、お客様ご自身でご確認ください。<br/>
      <span className="textRed">（現地移動につきましてはお客様負担となります）</span>
    </div>
  );

  const content = inboundFlight ? (
    <div className="subscriptionPlanContentItem">
      <PlanContent title={'帰り'}>
        <div className="subscriptionPlanContentInner">
          <Flight seat={false} flight={inboundFlight} />
          {!cantChangeFlight && (
            <div className="subscriptionPlanContentInnerButton">
              <LinkButton onClick={handleInboundFlightChange}>利用便を変更する</LinkButton>
            </div>
          )}
          {accessCaution}
        </div>
      </PlanContent>
    </div>
  ) : (
    <React.Fragment>
      {outboundFlight && (
        <div className="subscriptionPlanContentItem">
          <PlanContent title={'行き'}>
            <div className="subscriptionPlanContentInner">
              <Flight seat={false} flight={outboundFlight} />
              {!cantChangeFlight && (
                <div className="subscriptionPlanContentInnerButton">
                  <LinkButton onClick={handleOutboundFlightChange}>利用便を変更する</LinkButton>
                </div>
              )}
              {accessCaution}
            </div>
          </PlanContent>
        </div>
      )}
      <div className="subscriptionPlanContentItem">
        <PlanContent title={'宿泊'}>
          {plan ? (
            <React.Fragment>
              <ItinerarySchedule
                SP
                finalConfirm={finalConfirm}
                plan={plan}
                hideCheckin={hideCheckin}
                hideMessage={hideMessage}
                handleUpdateCheckin={handleUpdateCheckin}
                showQuestions={showQuestions}
                handleUpdateQuestion={handleUpdateQuestion}
              />
              {!cantChangeHotel && (
                <React.Fragment>
                  <div className="planButton">
                    <LinkButton onClick={handlePlanChange}>宿泊プランを変更する</LinkButton>
                    {index !== 1 && (<p className="caution">※組み合わせ可能な商品のみ表示されます</p>)}
                  </div>
                  {!cantDeleteHotel && (
                    <div className="planButton mt-15">
                      <LinkButton onClick={handlePlanDelete}>宿泊施設を削除する</LinkButton>
                    </div>
                  )}
                </React.Fragment>
              )}
              {message && !hideMessage && (
                <div className="planAttention">
                  <div className="title">施設に関するご案内・ご注意</div>
                  <div className="detail">
                    {message}
                  </div>
                </div>
              )}
            </React.Fragment>
          ) : (
            <div className="noPlan">
              <div className="noPlanText">宿泊プランが設定されていません</div>
              {ENABLE_MULTIPLE_HOTEL_PLAN && (
                <div className="planButton">
                  <LinkButton onClick={handlePlanChange}>宿泊内容を追加する</LinkButton>
                  {index !== 1 && (<p className="caution">※組み合わせ可能な商品のみ表示されます</p>)}
                </div>
              )}
            </div>
          )}
        </PlanContent>
      </div>
    </React.Fragment>
  );

  return (
    <React.Fragment>
      <div className="subscriptionPlanContent">
        <PlanDateTitle date={dateDisplay}>
          {index}日目
        </PlanDateTitle>
        {content}
      </div>
    </React.Fragment>
  );
};

SubscriptionPlanContentsItem.propTypes = {
  index: PropTypes.number.isRequired,
  outboundFlight: PropTypes.object,
  inboundFlight: PropTypes.object,
  dateDisplay: PropTypes.string,
  plan: PropTypes.object,
  handleOutboundFlightChange: PropTypes.func.isRequired,
  handleInboundFlightChange: PropTypes.func.isRequired,
  handlePlanChange: PropTypes.func.isRequired,
  handlePlanDelete: PropTypes.func.isRequired,
  cantChangeFlight: PropTypes.bool,
  cantChangeHotel: PropTypes.bool,
  cantDeleteHotel: PropTypes.bool,
  handleUpdateCheckin: PropTypes.func.isRequired,
  finalConfirm: PropTypes.bool,
  hideCheckin: PropTypes.bool,
  handleUpdateQuestion: PropTypes.func.isRequired,
  showQuestions: PropTypes.bool,
  hideMessage: PropTypes.bool,
};

export default SubscriptionPlanContentsItem;
